<template lang="pug">
.call-request
	VuePlaceholder(v-if="loading", type="form")
	template(v-else)
		CallRequestForm(v-if="resultState == RESULTSTATES.FORM", :privacy-data-url="privacyDataUrl", :financial-data-url="financialDataUrl", ref="form", :captcha-img="captcha.htmlFragment", :captcha-error="captchaError", @captcha-keyup="resetCaptchaError", :sending="sending", @submit="send")
			template(slot="info-text")
				slot(name="info-text")
		CallRequestSuccess(v-if="resultState == RESULTSTATES.SUCCESS", :modal-id="modalId")
		CallRequestError(v-if="resultState == RESULTSTATES.ERROR", :public-error-message="publicErrorMessage")
</template>

<script>
import CallRequestForm from './call-request-form/call-request-form';
import CallRequestSuccess from './call-request-success/call-request-success';
import CallRequestError from './call-request-error/call-request-error';
import callRequestApi from '../../api/call-request-api';
import VuePlaceholder from '@ui-common/vue-placeholder';
const RESULTSTATES = {
	FORM: 'FORM',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR'
};

export default {
	data: () => ({
		sending: false,
		loading: true,
		captcha: {
			captchaKey: null,
			htmlFragment: null
		},
		captchaError: false,
		resultState: RESULTSTATES.FORM,
		publicErrorMessage: null
	}),
	props: {
		privacyDataUrl: {
			required: false,
			type: String
		},
		financialDataUrl: {
			required: false,
			type: String
		},
		modalId: {
			required: true
		}
	},
	components: {
		CallRequestForm,
		CallRequestSuccess,
		CallRequestError,
		VuePlaceholder
	},
	watch: {
		resultState(val) {
			if (val == RESULTSTATES.SUCCESS || val == RESULTSTATES.ERROR) {
				this.$hideModalHeader(this.modalId);
			} else {
				this.$showModalHeader(this.modalId);
			}
		}
	},
	computed: {
		RESULTSTATES() {
			return RESULTSTATES;
		}
	},
	methods: {
		resetCallRequest() {
			this.resultState = RESULTSTATES.FORM;
			this.$nextTick(() => {
				this.resetCaptchaError();
				this.init();
				this.$refs.form.resetForm();
			});
		},
		resetCaptchaError() {
			this.captchaError = false;
		},
		async send(data) {
			try {
				this.sending = true;
				this.captchaError = false;
				const dataToSend = Object.assign({}, data, { captchaKey: this.captcha.captchaKey, url: window.location.href });
				await callRequestApi.submit(dataToSend);
				this.resultState = RESULTSTATES.SUCCESS;
			} catch (err) {
				if (err.response.status == 400) {
					if (err.response.data && err.response.data.error && err.response.data.error == 'captchaText') {
						this.captchaError = true;
						this.$refs.form.resetCaptcha();
						this.generateCaptcha();
					} else if (err.response.data && err.response.data.publicErrorMessage) {
						this.resultState = RESULTSTATES.ERROR;
						this.publicErrorMessage = err.response.data.publicErrorMessage;
					}
				} else {
					this.resultState = RESULTSTATES.ERROR;
				}
			} finally {
				this.sending = false;
			}
		},
		async generateCaptcha() {
			try {
				const response = await callRequestApi.generateCaptcha();
				this.captcha = response.data;
			} catch (err) {
				this.resultState = RESULTSTATES.ERROR;
			}
		},
		async init() {
			try {
				const response = await callRequestApi.init();
				this.captcha = response.data.captcha;
			} catch (err) {
				this.resultState = RESULTSTATES.ERROR;
			} finally {
				this.loading = false;
			}
		}
	},
	created() {
		this.init();
		this.$modalEventBus.$on('modal-closed', modalId => {
			if (modalId == this.modalId) {
				this.resetCallRequest();
			}
		});
	}
};
</script>

<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';
@import '~@ui-common/sf-style-utils/lib/helpers/_headings-mixins.scss';

.call-request-modal-body {
	@include media('<tablet') {
		margin-left: 16px;
		margin-right: 16px;
	}
}

.call-request__header .sf-form-info.sf-form-info--tip {
	margin-bottom: 32px;
}

.call-request__header .title-1 {
	@include sf-heading-2();
}

.call-request-feedback {
	padding-bottom: 32px;
	padding-top: 32px;

	@include media('>=tablet') {
		padding-bottom: 48px;
		padding-top: 48px;
	}

	@include media('>=desktop') {
		padding-bottom: 64px;
		padding-top: 64px;
	}
}
</style>
